//import store from '../store/index.js';
export default [
	{
		path: '/download/:formresponse_id?/:asset_id',
		component: () => import("../views/Download/DownloadFile.vue"),
	}
]